import { Select } from 'antd';
import { noop } from 'lodash';
import React from 'react';

import { useQuery } from 'react-query';
import { getThirdPartyRelationListByTpid } from 'services/thirdParty';

export type TpRelationSelectProps = {
  onChange?: any;
  value?: number;
  tpid: number;
};

const TpRelationSelect = ({
  onChange = noop,
  value,
  tpid,
}: TpRelationSelectProps) => {
  const { data, refetch, isLoading } = useQuery(
    ['getThirdPartyRelationListByTpid', { tpid: Number(tpid) }],
    () =>
      getThirdPartyRelationListByTpid({ tpid: Number(tpid) }).then(
        (res) => res.list || []
      ),
    { enabled: !!tpid }
  );

  return (
    <Select
      value={value}
      onChange={(e) => {
        onChange(e);
      }}
      loading={isLoading}
      allowClear
    >
      {data?.map((tp) => (
        <Select.Option value={tp.tpidtarget} key={tp.tpidtarget}>
          {tp.tpTargetname}
        </Select.Option>
      ))}
    </Select>
  );
};

export default TpRelationSelect;
